import React, { useState } from "react";
import * as c from '../../constants/config.js';

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
} from "react-bootstrap";

function UploadImage() {
  const user = JSON.parse(localStorage.getItem('user'));
   const initialState = {
    isSubmitting: false,
    errorMessage: null,
    redirect: false,
    errorCode:0
  };
  const [imageToBase64String, setImageToBase64String] = useState("");
  const [userId, setUserId] = useState(user == null ? ' ' : user.userId); 
  const [data, setData] = useState(initialState);

  /*
  const handleInputChange = event => {
    setData({
      ...data,
      [event.target.name]: event.target.value
    });
  };
  */

  const handleUserIdChange = event => {
      setUserId(event.target.value);
  };
  
  const handleFileInputChange = (e) => {
    console.log("file to upload " + e.target.files[0]);
    let file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (readerEvt) => {
        let binaryString = readerEvt.target.result
        setImageToBase64String(btoa(binaryString));
      };
      reader.readAsBinaryString(file);
    }
  }

  const handleSubmit = event => {
    event.preventDefault();

   if (userId.length === 0) {
      setData({
        isSubmitting: false,
        errorMessage: "Please enter a UserId",
        redirect: false
      });
      return;
    }
    setData({
      isSubmitting: true,
      errorMessage: null,
      redirect: false
    });

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));
    myHeaders.append("Content-Type", "application/json");

    let requestObject = {
      userId: userId,
      imageToBase64String: imageToBase64String
    }
    var raw = JSON.stringify(requestObject);
    var requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    console.log(requestObject)
    fetch(c.USER_UPLOAD_IMAGE, requestOptions)
      .then(response => {
        //response.text()
        if (response.ok) {
            return response.text();
        } else {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          console.log(response.headers.get('Content-Type'));
          console.log(response.headers.get('Date'));
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.type);
          console.log(response.url);
          //throw new Error('Network response was 500');
          throw response;
        }
      })
      .then(result => {
        console.log(result)
        
        setData({
          isSubmitting: false,
          errorMessage: null,
          redirect: true
        });

        alert("Successfully Uploaded");
        //preview.src = "data:image/png;base64," + imageToBase64String
      })
      .catch(error => { 
        console.log('error 1', error.message)
        setData({
          isSubmitting: false,
          errorMessage: error.message,
          //errorMessage: error.status || error.statusText,
          redirect: false,
          errorCode: error.status
        });
        console.log('error 2', data.errorMessage)
      });
  };

  const renderRedirect = () => {
      //console.log(data.redirect);
      if (data.errorCode == 401) {
        return <Redirect to='/auth/login-page'/>
      }
      if (data.redirect) {
          return <Redirect to='/admin/get-user-by-type'/>
      }
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Upload Image</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form method="POST" onSubmit={handleSubmit}>
                <Row>
                    <Col className="pr-1" md="6">
                      {data.errorMessage && (
                        <span className="form-error">{data.errorMessage}</span>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1" md="6">
                      <Form.Group>
                        <label>UserId</label>
                        <Form.Control
                          placeholder="userId"
                          type="text"
                          value={userId}
                          onChange={handleUserIdChange}
                          name="userId"
                          id="userId"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="6">
                      <Form.Group>
                        <label htmlFor="imageToBase64String">
                          imageToBase64String
                        </label>
                        <Form.Control
                          placeholder="imageToBase64String"
                          type="file"
                          accept=".jpeg, .png, .jpg"
                          onChange={handleFileInputChange}
                          name="imageToBase64String"
                          id="imageToBase64String"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      {data.errorMessage && (
                        <span className="form-error">{data.errorMessage}</span>
                      )}
                    </Col>
                  </Row>

                  <Button 
                    type="submit"
                    variant="info"
                    className="btn-fill pull-right" 
                    type="submit" 
                    disabled={data.isSubmitting ? true : false}>
                      Upload &nbsp;&nbsp;&nbsp;
                      {data.isSubmitting ? (
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : (
                          <span></span>
                      )}
                    </Button>

                  <div className="clearfix"></div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
         
        </Row>
      </Container>
      {renderRedirect()}
    </>
  );
}

export default UploadImage;
